import React, {ReactNode, useCallback} from 'react';
import cn from 'classnames';

import Grid from '@material-ui/core/Grid';
import Text from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';

export interface RowProps {
  className?: string;
  children: ReactNode;
  text?: boolean;
}

export const GridRow: React.FC<RowProps> = ({children, className, text}) => {
  const {row} = useStyles();
  const Wrapper = useCallback(
    ({children}) => {
      return (
        <Grid item xs={12} className={cn(row, className)}>
          {children}
        </Grid>
      );
    },
    [row, className]
  );

  if (text) {
    return (
      <Wrapper>
        <Text>{children}</Text>
      </Wrapper>
    );
  }
  return <Wrapper>{children}</Wrapper>;
};

const useStyles = makeStyles(() => ({
  row: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
  },
}));
